import { ContentLayout, Spinner } from 'bv-components';
import { remove } from 'bv-local-storage';
import { zendesk } from 'bv-services';
import { setLocation } from 'bv-helpers/location';

const Logout = () => {
  remove('stakes');
  remove('resumeToken');
  zendesk.logout();
  setLocation('/logout');
  return (
    <ContentLayout>
      <Spinner />
    </ContentLayout>
  );
};

export default Logout;
